import { useEffect } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router';

import { useAppSelector } from '~/application/hooks';
import { selectIsLoggedIn } from '~/application/store/auth';

export const AuthenticatedOutlet = () => {
    const isLoggedIn = useAppSelector(selectIsLoggedIn);
    const navigate = useNavigate();
    const { pathname } = useLocation();

    useEffect(() => {
        if (!isLoggedIn) {
            navigate('/login', {
                state: { from: pathname },
            });
        }
    }, [isLoggedIn, pathname]);

    return isLoggedIn
        ? <Outlet />
        : null;
};
